import { capitalize } from '@chainflip/utils/string';
import { useGqlQuery } from './useGqlQuery';
import { getRuntimeVersionQuery } from '../graphql/cache/environment';
import { formatRuntimeVersion, getChainflipNetwork } from '../utils';

export default function useNetworkInfo() {
  const { data } = useGqlQuery(getRuntimeVersionQuery, {
    context: { clientName: 'statechainCache' },
  });

  const version = data?.allEnvironmentAddresses?.nodes[0].runtimeVersion;

  if (!version) return capitalize(getChainflipNetwork());

  return `${capitalize(getChainflipNetwork())} ${formatRuntimeVersion(version)}`;
}
